const startOpacity = 1;
const endOpacity = 0.25;

export const calculateOpacity = (elements, currentElementIndex) => {
    let sortedOpacityArr = [];
    for (let index = 0; index < elements.length; index++) {
        const interpolatedOpacity =
            startOpacity + (endOpacity - startOpacity) * (index / (elements.length - startOpacity));
        sortedOpacityArr = [...sortedOpacityArr, interpolatedOpacity];
    }

    sortedOpacityArr = [
        ...sortedOpacityArr.splice(
            sortedOpacityArr.length - currentElementIndex,
            currentElementIndex
        ),
        ...sortedOpacityArr
    ];
    return sortedOpacityArr;
};
